import ajaxJson from "./ajax.js";
import dataPool from "./data.js";

//获取Token字符串
export const getToken = () => {
  return ajaxJson(dataPool.getToken);
};
//获取所属行业列表信息
export const getIndustryInfoList = () => {
  return ajaxJson(dataPool.getIndustryInfoList);
};
//获取人员类别列表信息
export const getMenTypeList = (data) => {
  return ajaxJson(dataPool.getMenTypeList, data);
};
//获取期次类型列表信息
export const getPeriodTypeList = (data) => {
  return ajaxJson(dataPool.getPeriodTypeList, data);
};
//获取期次列表信息
export const getPeriodInfoList = (data) => {
  return ajaxJson(dataPool.getPeriodInfoList, data);
};
//获取所属区域列表信息
export const getAreaInfoList = () => {
  return ajaxJson(dataPool.getAreaInfoList);
};
//获取集团公司列表信息
export const getCompanyGroupList = () => {
  return ajaxJson(dataPool.getCompanyGroupList);
};
//获取职务或工种列表信息
export const getWorkTypeList = (data) => {
  return ajaxJson(dataPool.getWorkTypeList, data);
};
//删除报名上传附件
export const removeSignUpAttachFile = (data) => {
  return ajaxJson(dataPool.removeSignUpAttachFile, data, 'POST');
};
//提交报名信息
export const signUpByUser = (data) => {
  return ajaxJson(dataPool.signUpByUser, data, 'POST');
};
//查询报名信息
export const querySignUpStatus = (data) => {
  return ajaxJson(dataPool.querySignUpStatus, data, 'POST');
};
//请求工行支付参数【培训服务费及住宿押金】
export const payForIcbc = (data) => {
  return ajaxJson(dataPool.payForIcbc, data);
};
//请求工行支付参数【仅培训服务费】
export const payForIcbcForTrain = (data) => {
  return ajaxJson(dataPool.payForIcbcForTrain, data);
};
//请求工行支付参数【仅住宿押金】
export const payForIcbcForDeposit = (data) => {
  return ajaxJson(dataPool.payForIcbcForDeposit, data);
};
//查询在线支付结果（5秒调用一次）
export const queryPayResult = (data) => {
  return ajaxJson(dataPool.queryPayResult, data);
};
//根据身份证号码、验证码查询学员培训档案打印信息
export const queryPrintTrainDataByIDCard = (data) => {
  return ajaxJson(dataPool.queryPrintTrainDataByIDCard, data, 'POST');
};
//根据报名编号、验证码查询培训档案打印信息
export const queryPrintTrainDocById = (data) => {
  return ajaxJson(dataPool.queryPrintTrainDocById, data);
};
//根据报名编号、验证码查询学时证明打印信息
export const queryPrintProveById = (data) => {
  return ajaxJson(dataPool.queryPrintProveById, data);
};
//查询历史报名信息
export const queryFrontSignUpInfo = (data) => {
  return ajaxJson(dataPool.queryFrontSignUpInfo, data, 'POST');
};


// WEBPACK FOOTER //
// ./src/api/index.js